"use client"

import { useState, useEffect } from "react"
import { Plus, PenTool, Calendar, DollarSign, Edit, Trash2, CheckCircle, Phone } from "lucide-react"
import { Bar } from "react-chartjs-2"
import Modal from "react-modal"

// Importante: Defina o elemento raiz do seu aplicativo para acessibilidade
Modal.setAppElement("#root")

const Manutencao = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false)
  const [manutencoes, setManutencoes] = useState([])
  const [formData, setFormData] = useState({
    nomeEmpresa: "",
    tipoManutencao: "",
    valorManutencao: "",
    dataPagamento: "",
    telefone: "",
    idUsuario: localStorage.getItem("idUsuario"),
  })
  const [editData, setEditData] = useState({ id: null, valorManutencao: "", telefone: "",dataPagamento: "" })
  const [manutencaoId, setManutencaoId] = useState(null)
  const [deleteId, setDeleteId] = useState(null)

  useEffect(() => {
    const idUsuario = localStorage.getItem("idUsuario")
    fetch(`https://sismoney.com/painel/saida_db.php?idUsuario=${idUsuario}`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setManutencoes(data)
        } else {
          console.error("Resposta da API não é um array", data)
        }
      })
      .catch((error) => console.error("Erro ao carregar manutenções:", error))
  }, [])

  const maintenanceData = {
    labels: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun"],
    datasets: [
      {
        label: "Gastos com Manutenção",
        data: [1200, 1900, 800, 1500, 2000, 1700],
        backgroundColor: "rgba(99, 102, 241, 0.5)",
      },
    ],
  }

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      }, 
    },
  }

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)

  const handleOpenEditModal = (manutencao) => {
    setEditData({
      id: manutencao.id,
      valorManutencao: manutencao.valor_manutencao,
      telefone: manutencao.telefone,
      dataPagamento: manutencao.data_pagamento,
    })
    setIsEditModalOpen(true)
  }

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false)
    setEditData({ id: null, valorManutencao: "", dataPagamento: "" })
  }

  const handleOpenDeleteModal = (id) => {
    setDeleteId(id)
    setIsDeleteModalOpen(true)
  }

  const handleCloseDeleteModal = () => {
    setDeleteId(null)
    setIsDeleteModalOpen(false)
  }

  const handleOpenConfirmModal = (id) => {
    setManutencaoId(id)
    setIsConfirmModalOpen(true)
  }

  const handleCloseConfirmModal = () => {
    setManutencaoId(null)
    setIsConfirmModalOpen(false)
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }))
  }

  const handleEditInputChange = (e) => {
    const { name, value } = e.target
    setEditData((prev) => ({ ...prev, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const response = await fetch("https://sismoney.com/painel/saida_db.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
      const result = await response.json()
      if (result.success) {
        setManutencoes((prev) => [...prev, { ...formData, pago: false }])
        handleCloseModal()
        window.location.reload()
      } else {
        console.error("Erro ao enviar os dados:", result.message)
      }
    } catch (error) {
      console.error("Erro na requisição:", error)
    }
  }

  const handleSaveEdit = async () => {
    try {
      const response = await fetch("https://sismoney.com/painel/saida_db.php", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(editData),
      })
      const result = await response.json()
      if (result.success) {
        setManutencoes((prev) =>
          prev.map((manutencao) =>
            manutencao.id === editData.id
              ? { ...manutencao, valor_manutencao: editData.valorManutencao, data_pagamento: editData.dataPagamento }
              : manutencao,
          ),
        )
        handleCloseEditModal()
      } else {
        console.error("Erro ao salvar edição:", result.message)
      }
    } catch (error) {
      console.error("Erro na requisição de edição:", error)
    }
  }

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`https://sismoney.com/painel/saida_db.php?id=${id}`, {
        method: "DELETE",
      })
      const result = await response.json()
      console.log(result)
      if (result.success) {
        setManutencoes((prev) => prev.filter((manutencao) => manutencao.id !== id))
        console.log(result.message)
        window.location.reload()
      } else {
        console.error("Erro ao excluir manutenção:", result.message)
      }
    } catch (error) {
      console.error("Erro na requisição de exclusão:", error)
    }
  }

  const togglePago = async (id) => {
    try {
      const response = await fetch("https://sismoney.com/painel/saida_db.php", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, pago: 1 }),
      })
  
      // Verificar se a resposta é válida antes de tentar fazer o parse
      if (!response.ok) {
        console.error("Erro no servidor:", response.statusText)
        return
      }
  
      const result = await response.json()
  
      if (result.success) {
        setManutencoes((prev) =>
          prev.map((manutencao) => (manutencao.id === id ? { ...manutencao, pago: !manutencao.pago } : manutencao)),
        )
        handleCloseConfirmModal()
        window.location.reload()
      } else {
        console.error("Erro ao atualizar status de pagamento:", result.message)
      }
    } catch (error) {
      console.error("Erro ao alternar status de pagamento:", error)
    }
  }
  const isAtrasado = (dataPagamento) => {
    const today = new Date()
    const pagamentoDate = new Date(dataPagamento)
    return pagamentoDate < today
  }

  const customModalStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "white",
      borderRadius: "8px",
      padding: "20px",
      maxWidth: "500px",
      width: "100%",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
    },
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-gray-800 dark:text-white">Módulo de Saida</h2>
          <p className="text-gray-600 dark:text-gray-400">Gerencie suas saidas aqui.</p>
        </div>
        <button
          onClick={handleOpenModal}
          className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
        >
          <Plus className="w-5 h-5 mr-2" />
          Adicionar Saida
        </button>
      </div>
      {/* NAO UTILIZAMOS */}
       {/*<div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Gastos com Saida</h3>
          <div className="h-80">
            <Bar data={maintenanceData} options={chartOptions} />
          </div>
        </div> 

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
          <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Últimas Manutenções</h3>
          <div className="space-y-4">
            {manutencoes.slice(0, 3).map((manutencao, index) => (
              <div key={index} className="flex items-center p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                <div className="p-3 bg-indigo-100 dark:bg-indigo-900/50 rounded-full mr-4">
                  <PenTool className="w-6 h-6 text-indigo-600 dark:text-indigo-400" />
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-gray-800 dark:text-gray-200">{manutencao.nome_empresa}</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400">{manutencao.tipo_manutencao}</p>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-gray-800 dark:text-gray-200">
                    R${" "}
                    {Number.parseFloat(manutencao.valor_manutencao).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </p>
                  <p className="text-sm text-gray-600 dark:text-gray-400">
                    {new Date(manutencao.data_pagamento).toLocaleDateString("pt-BR")}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div> */}

      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 transition-colors duration-200">
        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200 mb-4">Lista de Manutenções</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Nome da Empresa
                </th>
                <th scope="col" className="px-6 py-3">
                  Tipo
                </th>
                <th scope="col" className="px-6 py-3">
                  Valor
                </th>
                <th scope="col" className="px-6 py-3">
                  Data de Pagamento
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Telefone
                </th>
                <th scope="col" className="px-6 py-3">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              {manutencoes.map((manutencao) => (
                <tr
                  key={manutencao.id}
                  className={`${isAtrasado(manutencao.data_pagamento) ? "bg-red-100 dark:bg-red-900/20" : "bg-white dark:bg-gray-800"} border-b dark:border-gray-700`}
                >
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-white">{manutencao.nome_empresa}</td>
                  <td className="px-6 py-4">{manutencao.tipo_manutencao}</td>
                  <td className="px-6 py-4">
                    R${" "}
                    {Number.parseFloat(manutencao.valor_manutencao).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                  <td className="px-6 py-4">
                  {String(new Date(manutencao.data_pagamento).getUTCDate()).padStart(2, "0")}/
  {String(new Date(manutencao.data_pagamento).getUTCMonth() + 1).padStart(2, "0")}/
  {new Date(manutencao.data_pagamento).getUTCFullYear()}</td>
                  <td className="px-6 py-4">{manutencao.pago ? "Pago" : "Não Pago"}</td>
                  <td className="px-6 py-4">{manutencao.telefone}</td>
                  <td className="px-6 py-4 space-x-2">
                    <button
                      onClick={() => handleOpenEditModal(manutencao)}
                      className="text-indigo-600 hover:text-indigo-900 dark:hover:text-indigo-400"
                    >
                      <Edit className="w-5 h-5" />
                    </button>
                    <button
                      onClick={() => handleOpenConfirmModal(manutencao.id)}
                      className="text-green-600 hover:text-green-900 dark:hover:text-green-400"
                    >
                      <CheckCircle className="w-5 h-5" />
                    </button>
                    <button
                      onClick={() => handleOpenDeleteModal(manutencao.id)}
                      className="text-red-600 hover:text-red-900 dark:hover:text-red-400"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        style={customModalStyles}
        contentLabel="Cadastro de Saida"
      >
        <h2 className="text-2xl font-bold mb-4">Cadastro de Saida</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Nome da Empresa</label>
            <input
              type="text"
              name="nomeEmpresa"
              value={formData.nomeEmpresa}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Tipo de Saida</label>
            <input
              type="text"
              name="tipoManutencao"
              value={formData.tipoManutencao}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Valor da Saida</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="number"
                name="valorManutencao"
                value={formData.valorManutencao}
                onChange={handleInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Telefone</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Phone className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                name="telefone"
                value={formData.telefone}
                onChange={handleInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>


          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Data de Pagamento</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Calendar className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="date"
                name="dataPagamento"
                value={formData.dataPagamento}
                onChange={handleInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>



          <div className="flex justify-end space-x-3 pt-4">
            <button
              type="button"
              onClick={handleCloseModal}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">
              Salvar
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        isOpen={isEditModalOpen}
        onRequestClose={handleCloseEditModal}
        style={customModalStyles}
        contentLabel="Editar Saida"
      >
        <h2 className="text-2xl font-bold mb-4">Editar Saida</h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Valor da Saida</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <DollarSign className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="number"
                name="valorManutencao"
                value={editData.valorManutencao}
                onChange={handleEditInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">EDITAR TELEFONE</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Phone className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                name="telefone"
                value={editData.telefone}
                onChange={handleEditInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">Data de Pagamento</label>
            <div className="mt-1 relative rounded-md shadow-sm">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Calendar className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="date"
                name="dataPagamento"
                value={editData.dataPagamento}
                onChange={handleEditInputChange}
                required
                className="block w-full pl-10 pr-12 sm:text-sm border-gray-300 rounded-md focus:ring-indigo-500 focus:border-indigo-500"
              />
            </div>
          </div>
          <div className="flex justify-end space-x-3 pt-4">
            <button
              onClick={handleCloseEditModal}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancelar
            </button>
            <button
              onClick={handleSaveEdit}
              className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              Salvar
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isDeleteModalOpen}
        onRequestClose={handleCloseDeleteModal}
        style={customModalStyles}
        contentLabel="Confirmação de Exclusão"
      >
        <h2 className="text-2xl font-bold mb-4">Confirmação</h2>
        <p className="mb-4">Você tem certeza que deseja excluir este item? Essa ação não pode ser desfeita.</p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => handleDelete(deleteId)}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Sim, excluir
          </button>
          <button
            onClick={handleCloseDeleteModal}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
        </div>
      </Modal>

      <Modal
        isOpen={isConfirmModalOpen}
        onRequestClose={handleCloseConfirmModal}
        style={customModalStyles}
        contentLabel="Confirmação de Pagamento"
      >
        <h2 className="text-2xl font-bold mb-4">Confirmação</h2>
        <p className="mb-4">Você tem certeza que deseja marcar esta Saida como paga?</p>
        <div className="flex justify-end space-x-3">
          <button
            onClick={() => togglePago(manutencaoId)}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Sim, marcar como pago
          </button>
          <button
            onClick={handleCloseConfirmModal}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Manutencao

